export default "__VITE_IMAGE_ASSET__009bf8f6__";